<template>
  <fade-transition>
    <div class="alert" :class="[`alert-${type}`]" role="alert" v-if="isVisible">
      <slot v-if="!dismissible"></slot>
      <div v-else class="container">
        <slot></slot>
        <slot name="dismiss-icon">
          <button type="button" class="close pl-2" aria-label="Close" @click="dismissAlert">
            <i class="fas fa-window-close"></i>
          </button>
        </slot>
      </div>
    </div>
  </fade-transition>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';

export default {
  name: 'alert',
  emits: ['dismiss'],
  components: {
    FadeTransition
  },
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type',
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dismissAlert() {
      // DEPRECATED: this.visible = false;
      // Remplaced by event
      this.$emit('dismiss');
    },
  },
}
</script>
